import React from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  getTheme,
  mergeStyleSets,
  PrimaryButton,
  Text,
} from "@fluentui/react";

const dialogContentProps = {
  type: DialogType.normal,
  title: "Delete Snippet",
};

const getClassNames = (theme) =>
  mergeStyleSets({
    description: {
      display: "inline-block",
      fontWeight: "bold",
    },
    footer: {
      marginTop: theme.spacing[12],
    },
    cancelBtn: {
      color: theme.palette.themePrimary,
      border: `2px solid ${theme.palette.themePrimary}`,
    },
    deleteBtn: {
      background: theme.palette.errorRed,
      border: `1px solid ${theme.palette.errorRed}`,
      color: theme.palette.white,
      selectors: {
        ":hover": {
          background: theme.palette.errorRed,
        },
      },
    },
  });

const DeleteSnippetDialog = ({ open, handleOpen, onDelete, snippetDescription }) => {
  let theme = getTheme();
  let { description, footer, cancelBtn, deleteBtn } = getClassNames(theme);
  return (
    <Dialog hidden={!open} onDismiss={() => handleOpen(false)} dialogContentProps={dialogContentProps}>
      <Text variant="mediumPlus">
        Are you sure you want to delete snippet: <div className={description}>{snippetDescription}</div>?
      </Text>
      <DialogFooter className={footer}>
        <DefaultButton className={cancelBtn} onClick={() => handleOpen(false)} text="Cancel" />
        <PrimaryButton className={deleteBtn} onClick={onDelete} text="Delete" />
      </DialogFooter>
    </Dialog>
  );
};

export default DeleteSnippetDialog;
